export default "<p>our-program works!</p>\n"